import { useNavigate } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import LatestUpdates from "./components/LatestUpdates";
import HotRecommend from "./components/HotRecommend";
import SpecialPreview from "./components/SpecialPreview";
import IntroSection from "./components/IntroSection";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <HeroCarousel />

      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <section className="mt-10 animate-fade-up md:mt-12">
          <SectionHeading
            title="分类快捷入口"
            desc="按影视类型快速进入对应频道，浏览更高效"
          />
          <CategoryEntry />
        </section>

        <section className="mt-14 animate-fade-up">
          <SectionHeading
            title="最新上线"
            desc="电影与电视剧最新内容实时更新"
            actionText="查看更多"
            onAction={() => navigate("/category/movie")}
          />
          <LatestUpdates />
        </section>

        <section className="mt-14 animate-fade-up">
          <SectionHeading
            title="热门影视推荐"
            desc="根据播放热度与评分甄选的精选作品"
          />
          <HotRecommend />
        </section>

        <section className="mt-14 animate-fade-up">
          <SectionHeading
            title="影视专题推荐"
            desc="编辑精选的主题合集，发现更多好片"
            actionText="全部专题"
            onAction={() => navigate("/specials")}
          />
          <SpecialPreview />
        </section>

        <section className="mt-14 animate-fade-up">
          <IntroSection />
        </section>
      </div>
    </div>
  );
}